import { ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import * as validators from './index.js';
function register() {
    ModelService.registerValidator(validators.INTERVAL_THRESHOLD, validators.IntervalThresholdValidator);
    ModelService.registerValidator(validators.LENGTH_BETWEEN, validators.LengthBetweenValidator);
    ModelService.registerValidator(validators.MAX_ALPHAS, validators.MaxAlphasValidator);
    ModelService.registerValidator(validators.MAX_DIGITS, validators.MaxDigitsValidator);
    ModelService.registerValidator(validators.MAX_LENGTH, validators.MaxLengthValidator);
    ModelService.registerValidator(validators.MAX_VALUE, validators.MaxValueValidator);
    ModelService.registerValidator(validators.MIN_ALPHAS, validators.MinAlphasValidator);
    ModelService.registerValidator(validators.MIN_DIGITS, validators.MinDigitsValidator);
    ModelService.registerValidator(validators.MIN_LENGTH, validators.MinLengthValidator);
    ModelService.registerValidator(validators.MIN_VALUE, validators.MinValueValidator);
    ModelService.registerValidator(validators.NOT_CONTAINS, validators.NotContainsValidator);
    ModelService.registerValidator(validators.PHONE_NUMBER, validators.PhoneNumberValidator);
    ModelService.registerValidator(validators.REQUIRED_ENTRIES, validators.RequiredEntriesValidator);
    ModelService.registerValidator(validators.REQUIRED, validators.RequiredValidator);
    ModelService.registerValidator(validators.UNIQUE, validators.UniqueValidator);
}
export { register, };
//# sourceMappingURL=register.js.map